import { Panel } from "@/components/KpiCard";
import { SmartTable } from "@/components/SmartTable";
import { money } from "@/lib/api";

export const ThTropPanel = ({ groupes, total }) => (
  <Panel title="Taxe d'hébergement trop perçue auprès des voyageurs" testId="bilan-th-trop-panel">
    {!groupes.length ? (
      <p className="text-sm text-slate-500" data-testid="bilan-th-trop-vide">Aucun trop-perçu détecté. Importez le fichier détaillé des versements Airbnb (colonne « Taxes remises par Airbnb ») pour le calculer.</p>
    ) : (
      <div className="overflow-x-auto">
        <SmartTable id="th-trop" data-export-titre="TH perçue en trop" className="w-full text-sm">
          <thead><tr className="text-left text-xs uppercase tracking-wide text-slate-500">
            <th className="py-2 pr-3">Mois</th><th className="py-2 pr-3">Plateforme</th><th className="py-2 pr-3 text-right">Rés.</th>
            <th className="py-2 pr-3 text-right">TH remise</th><th className="py-2 pr-3 text-right">TH selon Revenu Québec</th><th className="py-2 text-right">Trop perçu</th>
          </tr></thead>
          <tbody>
            {groupes.map((g) => (
              <tr key={`${g.mois}-${g.plateforme}`} className="border-t border-slate-100" data-testid={`bilan-th-trop-${g.mois}-${g.plateforme}`}>
                <td className="py-2 pr-3">{g.mois}</td><td className="py-2 pr-3">{g.plateforme}</td><td className="py-2 pr-3 text-right tabular">{g.nb}</td>
                <td className="py-2 pr-3 text-right tabular">{money(g.th_remise)}</td><td className="py-2 pr-3 text-right tabular">{money(g.th_due)}</td>
                <td className="py-2 text-right tabular font-medium text-amber-700">{money(g.trop_percu)}</td>
              </tr>
            ))}
            <tr className="border-t-2 border-slate-300 font-semibold" data-st-fixe="">
              <td className="py-2 pr-3" colSpan={5}>Total de l'année</td>
              <td className="py-2 text-right tabular text-amber-700" data-testid="bilan-th-trop-total">{money(total)}</td>
            </tr>
          </tbody>
        </SmartTable>
        <p className="mt-3 text-xs text-slate-500">La plateforme calcule la taxe de 3,5 % sur le loyer + le ménage au lieu de la nuitée seule. Payé par les voyageurs : sans effet sur vos revenus.</p>
      </div>
    )}
  </Panel>
);
